import { commonViewTexts } from '../common';
import { createDialogCommonViewTexts } from './create-dialog-common';

const targetName = commonViewTexts.project;

export const createNewProjectDialogViewTexts = {
  title: `${targetName} 新規登録`,
  descriptions: createDialogCommonViewTexts.messageGenerator(targetName),
  labels: {
    registerer: commonViewTexts.registerer,
    projectName: `${targetName}名`,
    model: commonViewTexts.model
  }
} as const;
